module.exports = __webpack_public_path__ + "@/assets/img/MA-5000-black.5eba0691.jpg";